module.exports = __webpack_public_path__ + "static/media/6-bi-quyet.fb672655.jpeg";